import {
    AvatarQuality,
    StreamingEvents,
    VoiceChatTransport,
    VoiceEmotion,
    StartAvatarRequest,
    STTProvider,
    ElevenLabsModel,
    StreamingTalkingMessageEvent,
    UserTalkingMessageEvent,
    TaskType,
    TaskMode,
} from "@heygen/streaming-avatar";
import { useEffect, useRef, useState } from "react";

import { Button } from "@/shared/ui/Button";
import { AvatarConfig } from "./AvatarStreaming/ui/AvatarConfig";
// import { AvatarVideo } from "./AvatarSession/AvatarVideo";
// import { useStreamingAvatarSession } from "./logic/useStreamingAvatarSession";
// import { AvatarControls } from "./AvatarSession/AvatarControls";
// import { useVoiceChat } from "./logic/useVoiceChat";
// import { StreamingAvatarProvider, StreamingAvatarSessionState } from "./logic";
import { LoadingIcon } from "@/shared/ui/Icon/icons";
// import { MessageHistory } from "./AvatarSession/MessageHistory";

import { AVATARS } from "@/shared/const/avatar";
import { StreamingAvatarSessionState } from "@/features/avatar/const";
import { observer } from "mobx-react-lite";
import { AvatarControls } from "@/widgets/AvatarSideBar/ui/AvatarStreaming/ui/AvatarControls";
import { AvatarVideo } from "@/widgets/AvatarSideBar/ui/AvatarStreaming/ui/AvatarVideo";
import { useAvatar } from "@/widgets/AvatarSideBar/ui/AvatarStreaming/lib/useAvatar";
import { usePlayerStore } from "@/features/player/lib/usePlayerStore";

const DEFAULT_CONFIG: StartAvatarRequest = {
    quality: AvatarQuality.Low,
    avatarName: AVATARS[0].avatar_id,
    knowledgeId: undefined,
    voice: {
        rate: 1.5,
        emotion: VoiceEmotion.EXCITED,
        model: ElevenLabsModel.eleven_flash_v2_5,
    },
    language: "en",
    voiceChatTransport: VoiceChatTransport.WEBSOCKET,
    sttSettings: {
        provider: STTProvider.DEEPGRAM,
    },
};

export const InteractiveAvatar = observer(() => {
    const store = usePlayerStore();
    const { avatar, rag } = store;
    // const { startVoiceChat } = useVoiceChat();
    const [config, setConfig] = useState<StartAvatarRequest>(DEFAULT_CONFIG);

    const mediaStream = useRef<HTMLVideoElement>(null);
    const { startSessionV2 } = useAvatar({ avatarStore: avatar, config });

    // useEffect(() => {
    //     console.log("useEffect");
    //     return () => {
    //         avatar.stop();
    //     };
    // }, []);

    useEffect(() => {
        const startSession = async () => {
            await startSessionV2(false);
        };
        if (rag.answer) {
            console.log("startSession", rag.answer);
            startSession();
        }
    }, [rag.answer]);

    useEffect(() => {
        if (avatar.sessionState === StreamingAvatarSessionState.CONNECTED) {
            console.log("answer");
            if (rag.answer?.answer.tts.main) {
                avatar.avatarStream?.speak({
                    text: rag.answer?.answer.tts.main,
                    taskType: TaskType.REPEAT,
                    taskMode: TaskMode.ASYNC,
                });
            }
        }
    }, [avatar.sessionState, rag.answer]);

    useEffect(() => {
        if (avatar.stream && mediaStream.current) {
            mediaStream.current.srcObject = avatar.stream;
            mediaStream.current.onloadedmetadata = () => {
                mediaStream.current!.play();
            };
        }
    }, [mediaStream, avatar.stream]);

    return (
        <div className="w-full flex flex-col gap-4">
            <div className="flex flex-col rounded-xl bg-zinc-900 overflow-hidden">
                <div className="relative w-full aspect-video overflow-hidden flex flex-col items-center justify-center">
                    {(avatar.sessionState !==
                        StreamingAvatarSessionState.INACTIVE ||
                        rag.loading) && <AvatarVideo ref={mediaStream} />}
                    <AvatarConfig config={config} onConfigChange={setConfig} />
                </div>
                <div className="flex flex-col gap-3 items-center justify-center p-4 border-t border-zinc-700 w-full">
                    {/*{avatar.sessionState ===*/}
                    {/*    StreamingAvatarSessionState.CONNECTED && (*/}
                    {/*    <AvatarControls />*/}
                    {/*)}*/}
                    {/*{avatar.sessionState ===*/}
                    {/*    StreamingAvatarSessionState.INACTIVE && (*/}
                    {/*    <div className="flex flex-row gap-4">*/}
                    {/*        /!*<Button onClick={() => startSessionV2(true)}>*!/*/}
                    {/*        /!*    Start Voice Chat*!/*/}
                    {/*        /!*</Button>*!/*/}
                    {/*        <Button onClick={() => startSessionV2(false)}>*/}
                    {/*            Start Text Chat*/}
                    {/*        </Button>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                    {(avatar.sessionState ===
                        StreamingAvatarSessionState.CONNECTING ||
                        rag.loading) && <LoadingIcon />}
                </div>
            </div>
            {avatar.sessionState === StreamingAvatarSessionState.CONNECTED && (
                <div>MessageHistory</div> // <MessageHistory />
            )}
        </div>
    );
});
